import { Modal, Button } from 'antd';
import React from 'react';

export interface DetailField {
  label: string;
  key: string;
  render?: (value: any, record: any) => React.ReactNode;
  wordBreak?: boolean;
  monospace?: boolean;
}

export interface DetailModalProps {
  title?: string;
  open: boolean;
  loading?: boolean;
  data: any;
  fields: DetailField[];
  onClose: () => void;
  width?: number;
}

const DetailModal: React.FC<DetailModalProps> = ({
  title = '详情',
  open,
  loading = false,
  data,
  fields,
  onClose,
  width = 900,
}) => {
  const getFieldValue = (field: DetailField): React.ReactNode => {
    const value = data?.[field.key];
    
    if (field.render) {
      return field.render(value, data);
    }
    
    if (value === null || value === undefined || value === '') {
      return '-';
    }
    
    return String(value);
  };

  return (
    <Modal
      title={title}
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          关闭
        </Button>,
      ]}
      width={width}
      loading={loading}
    >
      {data && (
        <div style={{ maxHeight: '600px', overflowY: 'auto' }}>
          <div style={{ padding: '16px 0' }}>
            {fields.map((field, index) => (
              <div
                key={index}
                style={{ marginBottom: '16px', display: 'flex', alignItems: 'flex-start' }}
              >
                <div style={{ width: '120px', fontWeight: 'bold', flexShrink: 0 }}>
                  {field.label}：
                </div>
                <div
                  style={{
                    flex: 1,
                    wordBreak: field.wordBreak ? 'break-all' : 'normal',
                    ...(field.monospace
                      ? {
                          fontFamily: 'monospace',
                          fontSize: '12px',
                          whiteSpace: 'pre-wrap',
                        }
                      : {}),
                  }}
                >
                  {getFieldValue(field)}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default DetailModal;

